import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import qs from 'qs';
import VideoGroup from './components/VideoGroup';
import Keys from '@/components/Keys';
import RightContainer from './components/RightContainer';
import { actionSendSocketData, actionSendHttpRequest } from '@/redux/action';
import CenterBox from './components/CenterBox';
import AllActionType from '@/redux/actionType';
import { RootState } from '@/redux/store';
import './single.scss';
import { api } from '@/fetch/bussiness/api';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import { formatMapData, getPermissionById, isEmpty } from '@/utils';
import classNames from 'classnames';
import {
  tabKeys,
  PermissionTab,
  CLSTAG,
  VehicleSupplier,
} from '@/utils/constant';
import { clstagStr } from '@/utils/util';
import memoryMonitor from '@/utils/memoryMonitor';
import MemoryMonitorComponent from '@/components/MemoryMonitor';
import MemoryDashboard from '@/components/MemoryMonitor/MemoryDashboard';

let timer: any = null;
const SingleView = () => {
  const dispatch = useDispatch();
  const query = qs.parse(window.location.search.split('?')[1]);
  const tabKey = query && query.tabKey;
  const license = query && query.license;
  const source = query && query.source;
  const rightTab = query && query.rightTab;
  const login = useSelector((state: RootState) => state.login);
  const singleVehiclePageInfo = useSelector(
    (state: RootState) => state.singleVehiclePageInfo
  );
  const common = useSelector((state: RootState) => state.common);
  const {
    tabType,
    singleVehiclePosition,
    mapScheduleUpdate,
    vehicleBasicInfoNew,
  } = singleVehiclePageInfo;
  const { connectionState, alarmEventList } = common;
  const [activeMode, setActiveMode] = useState<string>('3DMap');
  const [tabItems, setTabItems] = useState<any>([
    {
      key: tabKeys.threeDimension,
      label: '3D模块',
      clstag: CLSTAG.ThreeMonitor,
    },
    {
      key: tabKeys.workOrderRecord,
      label: '工单记录',
      clstag: CLSTAG.SinglePage_WorkOrderRecord,
    },
    {
      key: tabKeys.eventRecord,
      label: '事件记录',
      clstag: CLSTAG.SinglePage_EventRecord,
    },
    {
      key: tabKeys.manualEventRecord,
      label: '人工记录',
      clstag: CLSTAG.SinglePage_ManualEventRecord,
    },
  ]);
  const [activeKey, setActiveKey] = useState<string>(
    tabKey || tabKeys.threeDimension
  );
  const [mapData, setMapData] = useState<{
    station: Record<string, any>;
    vehicle: Record<string, any>;
    stop: Record<string, any>;
    city?: Record<string, any>;
    finishedRoutingPoint: Record<string, RoutingCoordinate[]>;
    currentRoutingPoint: RoutingPathMap;
    zoom: number;
    centerPoint?: [number, number];
  }>({
    station: {},
    vehicle: {},
    stop: {},
    finishedRoutingPoint: {},
    currentRoutingPoint: {},
    zoom: 15,
  });
  const [openJiraModal, setOpenJiraModal] = useState(false); // 事故排查触发问题提报
  const [selectAccident, setSelectAccident] = useState<any>(null);
  const [showMemoryDashboard, setShowMemoryDashboard] = useState(false); // Memory dashboard visibility
  useEffect(() => {
    fetchVehicleBasicInfoNew();
  }, []);
  useEffect(() => {
    if (tabType && connectionState === 'CONNECTION_OK') {
      getRealTimeDetailInfo();
    }
  }, [tabType, connectionState]);

  useEffect(() => {
    if (connectionState === 'CONNECTION_OK' && activeMode === 'mapMode') {
      subscripeScheduleChange();
    }
  }, [connectionState, activeMode]);
  useEffect(() => {
    if (!isEmpty(login.resourceList)) {
      setTabItems([
        {
          key: tabKeys.threeDimension,
          label: '3D模块',
          disable: !getPermissionById(PermissionTab.SPV_THREE_DIMENSION),
        },
        {
          key: tabKeys.workOrderRecord,
          label: '工单记录',
          disable: !getPermissionById(PermissionTab.SPV_WORKORDER_RECORD),
        },
        {
          key: tabKeys.eventRecord,
          label: '事件记录',
          disable: !getPermissionById(PermissionTab.SPV_EVENT_RECORD),
        },
        {
          key: tabKeys.manualEventRecord,
          label: '人工记录',
          disable: !getPermissionById(PermissionTab.SPV_MANUAL_EVENT_RECORD),
        },
      ]);
    }
  }, [login]);
  /**
   * 车辆单车页实时信息,ws定时推
   */
  const getRealTimeDetailInfo = () => {
    const requestData = {
      data: { vehicleName: license, tabType: tabType },
      eventType: AllActionType.SINGLE_VEHICLE,
    };
    dispatch(actionSendSocketData(JSON.stringify(requestData)));
  };
  /**
   * 车辆基础数据接口
   */
  const fetchVehicleBasicInfoNew = () => {
    const data: HTTPFetchActionParams = {
      method: 'POST',
      path: `${api.getVehicleInfo}`,
      body: {
        vehicleName: license,
      },
      actionType: AllActionType.MONITOR_VEHICLE_BASE_INFO,
    };
    dispatch(actionSendHttpRequest(data));
  };
  const handleChangeMapType = (type: string) => {
    setActiveMode(type);
    getRealTimeDetailInfo();
    if (type === 'mapMode') {
      fetchVehicleRouting();
      subscripeScheduleChange();
    } else {
      unSubscripeScheduleChange();
      timer && clearTimeout(timer);
    }
  };

  const startPushVehiclePosition = () => {
    const requestData = {
      eventType: AllActionType.MAP_VEHICLE_POSITION_REQUEST,
      data: {
        vehicleName: [license],
      },
    };
    dispatch(actionSendSocketData(JSON.stringify(requestData)));
  };
  /**
   * 全量获取车辆路径和位置
   */
  const fetchVehicleRouting = () => {
    request({
      path: `/monitor/web/map/vehicle/list`,
      method: 'POST',
      body: {
        vehicleName: [license],
      },
    }).then((res: HTTPResponse) => {
      if (res?.code === HttpStatusCode.Success && res?.data) {
        const resData = formatMapData({
          nation: false,
          station: {
            [res.data.station.id]: res.data.station,
          },
          vehicle: res.data.vehicle,
          zoom: 15,
          showFinishedRouting: true,
        });
        const { lat, lon } = res.data.vehicle[license] || {};
        if (lat && lon) {
          resData.centerPoint = [lat, lon];
        }
        setMapData({
          ...mapData,
          ...resData,
        });
        startPushVehiclePosition();
      }
    });
  };
  /**
   *
   * @param {'START' | 'STOP'} type 开启推送实时位置/停止推送实时位置
   */
  const toggleStartOrStopVehiclePosition = (type: 'START' | 'STOP') => {
    const requestData = {
      eventType: AllActionType.VEHICLE_MAP_REQUEST_SCHEDULE_POSITION,
      data: {
        vehicleName: license,
        type,
      },
    };
    dispatch(actionSendSocketData(JSON.stringify(requestData)));
  };

  /**
   * 订阅站点下车辆的调度变化
   * @param {string[]} vehicles 车号列表
   */
  const subscripeScheduleChange = () => {
    const requestData = {
      eventType: AllActionType.MAP_VEHICLE_SCHEDULE_REQUEST,
      data: {
        vehicleName: [license],
      },
    };

    dispatch(actionSendSocketData(JSON.stringify(requestData)));
  };

  /**
   * 取消调度状态变化的订阅
   */
  const unSubscripeScheduleChange = () => {
    const requestData = {
      eventType: AllActionType.MAP_VEHICLE_SCHEDULE_CANCEL_REQUEST,
    };
    dispatch(actionSendSocketData(JSON.stringify(requestData)));
  };

  /**
   * 地图模式下开启轮询获取车辆位置接口
   */
  useEffect(() => {
    if (activeMode === 'mapMode' && singleVehiclePosition.timeStamp != 0) {
      timer = setTimeout(() => {
        clearTimeout(timer);
        startPushVehiclePosition();
      }, 3000);
    }

    return () => {
      timer && clearTimeout(timer);
    };
  }, [singleVehiclePosition.timeStamp]);

  useEffect(() => {
    if (activeMode === 'mapMode' && singleVehiclePosition.timeStamp != 0) {
      const { scheduleState, lat, lon } =
        singleVehiclePosition.data[license] || {};
      const finishedRoutingPath = mapData.finishedRoutingPoint[license] || [];
      if (
        ['SETOUT', 'RETURN', 'TOLOAD', 'TOUNLOAD'].includes(scheduleState) &&
        lat &&
        lon
      ) {
        finishedRoutingPath.push({
          lat,
          lon,
        });
      }
      const vehicleData = Object.assign(
        {},
        mapData.vehicle[license],
        singleVehiclePosition.data[license],
        {
          hasAlarmEvent: alarmEventList[license],
        }
      );
      const realData = {
        ...mapData,
        vehicle: {
          [license]: vehicleData,
        },
        finishedRoutingPoint: {
          [license]: finishedRoutingPath,
        },
      };

      setMapData(realData);
    }
  }, [
    singleVehiclePosition.timeStamp,
    activeMode,
    Object.keys(alarmEventList).length,
  ]);

  useEffect(() => {
    if (activeMode === 'mapMode' && mapScheduleUpdate.timeStamp != 0) {
      fetchVehicleRouting();
    }
  }, [mapScheduleUpdate.timeStamp]);

  // 事故排查-提报jira
  const handleSubmitJira = (val: any) => {
    setSelectAccident(val);
    setOpenJiraModal(!openJiraModal);
  };

  const closeJiraModalCb = () => {
    setOpenJiraModal(false);
    setSelectAccident(null);
  };

  // Check if memory monitoring should be enabled
  const shouldEnableMonitoring = () => {
    // Always enable in development environment
    // if (process.env.NODE_ENV === 'development') return true;

    // In production, check for URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('showMemoryMonitor');
  };

  // Start memory monitoring when component mounts
  useEffect(() => {
    if (shouldEnableMonitoring()) {
      memoryMonitor.start();

      // Log initial memory usage
      const initialSample = memoryMonitor.takeSample();
      if (initialSample) {
        console.log('Initial memory usage:', initialSample);
      }

      return () => {
        // Don't stop the monitor on unmount as it might be used elsewhere
        // But we can log the final memory usage
        const finalSample = memoryMonitor.takeSample();
        if (finalSample) {
          console.log('Final memory usage:', finalSample);
          console.log('Memory stats:', memoryMonitor.getStats());
        }
      };
    }
  }, []);

  return (
    <>
      <div className="single-vehicle-monitor-page">
        <div className="content-wrapper">
          <div className="left-container">
            <div className="video-container">
              <VideoGroup
                license={license}
                userInfo={login && login.user}
                source={source}
              />
            </div>
          </div>
          <div className="middle-container">
            <div className="top-tabs-container">
              {tabItems.map((tabItem: any) => {
                if (tabItem.disable) {
                  return <></>;
                }
                return (
                  <>
                    <div
                      className={classNames('tab-container', {
                        'tab-container-active': activeKey === tabItem.key,
                      })}
                      key={tabItem.key}
                      onClick={() => {
                        setActiveKey(tabItem.key);
                      }}
                      clstag={clstagStr(tabItem.clstag)}
                    >
                      <div
                        className={classNames('tab-label', {
                          'tab-label-active': activeKey === tabItem.key,
                        })}
                      >
                        {tabItem.label}
                      </div>
                      <div
                        className={classNames('tab-ink', {
                          'tab-ink-active': activeKey === tabItem.key,
                        })}
                      ></div>
                    </div>
                  </>
                );
              })}
            </div>
            <CenterBox
              activeKey={activeKey}
              mapData={mapData}
              license={license}
              handleChangeMapType={handleChangeMapType}
              toggleStartOrStopVehiclePosition={
                toggleStartOrStopVehiclePosition
              }
            />
            <Keys
              userInfo={login && login.user}
              license={license}
              openJiraModal={openJiraModal}
              selectAccident={selectAccident}
              closeJiraModalCb={closeJiraModalCb}
              disabled={vehicleBasicInfoNew?.supplier !== VehicleSupplier.JD}
              vehicleSupplier={vehicleBasicInfoNew?.supplier}
            />
          </div>
          <div className="right-container">
            <RightContainer
              vehicleName={license}
              singleVehiclePageInfo={singleVehiclePageInfo}
              rightTab={rightTab}
            />
          </div>
        </div>
      </div>
      {/* Show memory monitor based on environment or URL parameter */}
      {shouldEnableMonitoring() && (
        <>
          <MemoryMonitorComponent
            position="bottom-right"
            interval={5000}
            onlyDevelopment={true}
            showUI={true}
          />
          <div
            style={{
              position: 'fixed',
              bottom: '10px',
              left: '10px',
              zIndex: 9999,
              cursor: 'pointer',
              background: 'rgba(0, 0, 0, 0.7)',
              color: 'white',
              padding: '8px 12px',
              borderRadius: '4px',
              fontSize: '12px',
            }}
            onClick={() => setShowMemoryDashboard(true)}
          >
            Open Memory Dashboard
          </div>
          <MemoryDashboard
            visible={showMemoryDashboard}
            onClose={() => setShowMemoryDashboard(false)}
          />
        </>
      )}
    </>
  );
};

export default React.memo(SingleView);
